var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offline-message"},[_c('p',[_vm._v("Olá! Sentimos muito, mas o WhatsApp lançou uma atualização e por conta disso as integrações estão fora do ar.")]),_c('p',[_vm._v("Nosso time de desenvolvimento já está trabalhando para regularizar.")]),_c('p',[_vm._v("Em breve estará pronto para o uso.")])])
}]

export { render, staticRenderFns }